/**
 * Shared Agent-surface API plumbing for strategy-blocks services that call
 * the CLI facade (`/api/cli/v1/...`) with the signed-in user's Firebase token.
 * Single source for the base-URL resolution — do not copy it per service.
 */

import { getAuth } from 'firebase/auth';

export function getBuilderApiBaseUrl(): string {
  if (import.meta.env.VITE_AGENT_API_URL) return import.meta.env.VITE_AGENT_API_URL;
  if (import.meta.env.VITE_BUILDER_API_URL) return import.meta.env.VITE_BUILDER_API_URL;
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'http://localhost:8080';
  if (hostname === 'dev.segmently.ai' || hostname.includes('devsegmentlyai')) return 'https://dev-api.segmently.ai';
  if (hostname === 'stage.segmently.ai' || hostname.includes('stagesegmentlyai')) return 'https://stage-api.segmently.ai';
  return 'https://api.segmently.ai';
}

export async function builderAuthHeader(): Promise<Record<string, string>> {
  const token = await getAuth().currentUser?.getIdToken();
  if (!token) throw new Error('User not authenticated');
  return { Authorization: `Bearer ${token}` };
}
